import React, { FC } from 'react'
import Link from 'next/link'
import { useTranslation } from 'next-i18next/pages'
import { useWishlist } from './Hooks/use-wishlist'
import { useUI } from '@corratech/pylot-ui/context'
import { WishlistContent } from './WishlistContent'
import { ErrorPage } from '@components/common/ErrorPage'
import { NoWishlistFound } from '.'
import Head from 'next/head'
import cn from 'classnames'
import s from '@pagestyles/Wishlist.module.scss'
import formStyles from '@commonStyles/Forms.module.scss'
import { AccountRowChevronIcon } from '@components/account/AccountHomeQuickLinkIcons'

export type Props = {
    id: string | string[]
}

export const WishlistView: FC<Props> = ({ id }) => {
    const { t } = useTranslation(['wishlist', 'account', 'common'])
    const { loading, getWishlistById, wishlists, error } = useWishlist()
    const { LoadingIndicator } = useUI()
    const rawId = Array.isArray(id) ? id[0] : id
    const wishlistId = rawId != null && rawId !== '' ? String(rawId) : ''

    if (error || !wishlistId) {
        return <ErrorPage />
    }

    if (loading) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    const wishlist = getWishlistById(wishlistId)

    return (
        <>
            <Head>
                <title>
                    {wishlist?.name!}
                    {t(' | Casaideas')}
                </title>{' '}
            </Head>
            <div className={cn(s['wishlist-container'], formStyles.root)}>
                <Link
                    href="/account/wishlist"
                    className={s.backLink}
                    aria-label={t(
                        'account||account|Wishlist detail back label'
                    )}
                >
                    <span className={s.backChevron}>
                        <AccountRowChevronIcon />
                    </span>
                    <span className={s.backText}>
                        {t('account||account|Wishlist detail back label')}
                    </span>
                </Link>
                <div className={s['wishlist-header']}>
                    <p className={s['wishlist-title']}>
                        {t('account||account|My Wish List')}
                    </p>
                </div>
                <div className={s['wishlist-tabs']}>
                    {wishlists?.length && wishlist ? (
                        <WishlistContent wishlist={wishlist} />
                    ) : (
                        <NoWishlistFound />
                    )}
                </div>
            </div>
        </>
    )
}
